import { fabric, } from 'fabric';

const initCanvas = (options) => (
    new fabric.Canvas('canvas', options)
);

export { initCanvas }